
import CommodityList from './list.vue'
import CommodityEdit from "./edit.vue";

let a = Object.assign({CommodityList,CommodityEdit});
export default a;